import { useMemo } from "react";

import { useProductConfig } from "../useProductConfig";
import { useProductLicenseInfo } from "../useProductLicenseInfo";
import { useSupportsFeature } from "../useSupportsFeature";

export const useHasSecretsAccess = () => {
  const { data: productConfig, isLoading: isConfigLoading } =
    useProductConfig();

  const hasSecretsAccess = useSupportsFeature("hasSecretsProduct");
  const secretsLicenseInfo = useProductLicenseInfo("secrets");

  const hasSecrets = useMemo(
    () =>
      hasSecretsAccess ||
      productConfig?.secrets.enabled ||
      !!secretsLicenseInfo?.license ||
      !!secretsLicenseInfo?.hasTrial,
    [
      hasSecretsAccess,
      productConfig?.secrets.enabled,
      secretsLicenseInfo?.license,
      secretsLicenseInfo?.hasTrial,
    ]
  );

  return {
    hasSecrets,
    hasEnabledSecrets: productConfig?.secrets.enabled ?? false,
    isLoading: isConfigLoading,
  };
};
